import axios from "axios";
import {API} from './api.js';
const API_URL = API + '/audittrail/'
//const API_URL = "http://localhost:3000/api/audittrail/";
//const API_URL = "http://192.168.3.108:3000/api/audittrail/";

//get the total number of the documents present in collection
//Get the n records = per page record, init record number will be the page number-1
// map the received data value dynamically as row lsit
// Map the key names of received data dynamically as column list


//Get count of records present in table
const getRowsCount = (dashboardName) => {

  return axios.post(API_URL + "count", {
    dashboardName,
    })
    
};


// get specific rows data, init record = page * rowsPerPage and number of record to fetch = rowsPerPage
const getRowsData = (dashboardName, offset, rowsPerPage) => {

  return axios.post(API_URL + "data", {
      dashboardName,
      offset,
      rowsPerPage
    })
};

// Get all rows data present inside the table
const getAllRowsData = (dashboardName) => {
  return axios.post(API_URL + "all", {
    dashboardName,
  });
 
};

// Get all rows data present inside the table
const getColumnData = (dashboardName, columnName, columnValue) => {
  return axios.post(API_URL + "columnData", {
    dashboardName,
    columnName,
    columnValue,
  });
 
};

// Get all field names of the specific table/collection
const getSchemaKeys = (dashboardName) => {
  return axios.post(API_URL + "schemaKeys", {
    dashboardName,

  });
 
};


// Save specific row data present inside the table
const updateRowData = (dashboardName, rowData) => {

  return axios.post(API_URL + "update", {
    dashboardName,
    rowData,
  });
   
};


// Create or Add document/record to existing collection/table
const createRow= (dashboardName, rowData) => {
    return axios.post(API_URL + "create", {
      dashboardName,
      rowData,
      })
};

//get data from table/document(dashboardName), retrieve specific column's(columnsToRetrieve) data based on specific values(valueToMatch ) of one of the column(columnToFilter)
const getMultiColumnsRows=(dashboardName, columnsToRetrieve, columnToFilter, valueToMatch ) => {
  return axios.post(API_URL + "multiColumnsRows", {
    dashboardName, 
    columnsToRetrieve,
    columnToFilter,
    valueToMatch
  })

};

// insert multiple document/record to existing collection/table
const insertMultipleRow=(dashboardName, userData, auditTrailData ) => {
  return axios.post(API_URL + "multiInsert", {
    dashboardName, 
    userData,
    auditTrailData
  })

};

// delete multiple document/record of existing collection/table for specific condition ie delete data if values matches for given fields.
const deleteMultipleRows=(dashboardName, projectName, dashboardType, widgetName ) => {
  return axios.post(API_URL + "deleteMany", {
    dashboardName, 
    projectName,
    dashboardType, 
    widgetName 
  })

};

// Delete specific document/record from existing collection/table
const deleteRow = (dashboardName, rowId) => {
    return axios.post(API_URL + "delete", {
      dashboardName,
      rowId,
      })
  };

//Delete selected Groupname from specific List named as arrayField for all docs
const DeleteArrayItemFromAllDocs = (dashboardName, arrayField, valueToDelete, rowData, auditTrailData) => {
  return axios.post(API_URL + "DeleteArrayItemFromAllDocs", {
    dashboardName,
    arrayField, 
    valueToDelete,
    rowData,
    auditTrailData,
    })
};


  
// Get data from back end by providing To and From datetime with specific list of the parameters.
const getDataLogColumnData = (fromDateTime, toDateTime, parameterList, fieldName, fieldValue) => {
  //console.log(fromDateTime, toDateTime, parameterList)
  return axios.post(API_URL + "DataLogColumnData", {
    fromDateTime,
    toDateTime,
    parameterList,
    fieldName,
    fieldValue,

  });

};

// Get data of specific role and user from back end by providing To and From datetime with specific list of the parameters.
const getFilteredData = (dbName, fromDateTime, toDateTime, role, user, fieldNameList) => {
  //console.log(fromDateTime, toDateTime, parameterList)
  return axios.post(API_URL + "FilteredData", {
    dbName,
    fromDateTime,
    toDateTime,
    role,
    user,
    fieldNameList,
  });

};


const AuditTrailService = {
  getRowsCount,
  getRowsData,
  getAllRowsData,
  updateRowData,
  getColumnData,
  createRow,
  insertMultipleRow,
  deleteRow,
  DeleteArrayItemFromAllDocs,
  deleteMultipleRows,
  getMultiColumnsRows,
  getSchemaKeys,
  getDataLogColumnData,
  getFilteredData,

}

export default AuditTrailService;